import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import CustomerTopNav from './CustomerTopNav.jsx';
import { getUser } from '../../../auth.js';
import { connectAndGetSocket, disconnectSocket } from '../../../socket.js';
import '../index.css';

const TITLE_RULES = [
  { keyword: 'order', color: '#2d1b69' },
  { keyword: 'discount', color: '#d4156a' },
  { keyword: 'product', color: '#10b981' },
];

function getTitleColor(title) {
  const lower = title.toLowerCase();
  for (const r of TITLE_RULES) {
    if (lower.includes(r.keyword)) return r.color;
  }
  return '#4b1fd0';
}

function NotifIcon({ title }) {
  if (!title) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--purple)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    );
  }
  const letter = title.charAt(0).toUpperCase();
  const color = getTitleColor(title);
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill={color} />
      <text x="12" y="12" textAnchor="middle" dominantBaseline="central" fill="white" fontSize="14" fontWeight="700">
        {letter}
      </text>
    </svg>
  );
}

export default function CustomerLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = getUser();
    if (user?.userType === "customer") {
      connectAndGetSocket();
    }
    return () => {
      disconnectSocket();
    };
  }, []);

  useEffect(() => {
    const socket = connectAndGetSocket();
    if (!socket) return;

    const handler = (payload) => {
      notification.open({
        message: payload.title || payload.message,
        description: payload.title ? payload.message : undefined,
        placement: "bottomRight",
        duration: 3,
        className: `customer-notification-toast${payload.title ? ' customer-notification-toast--with-title' : ''}`,
        icon: <NotifIcon title={payload.title} />,
        style: payload.title ? { borderLeftColor: getTitleColor(payload.title) } : undefined,
        onClick: payload.url?.startsWith('/customer') ? () => navigate(payload.url) : undefined,
      });
    };

    socket.on("notification", handler);
    return () => socket.off("notification", handler);
  }, [navigate]);

  return (
    <div className="customer-portal-customer-shell">
      <CustomerTopNav />
      <main>
        <Outlet />
      </main>
    </div>
  );
}